<template>
    <ul>

        <li class="group row m-b-20">
            <label for="turnaround" class="col-sm-5">
                Job Name
            </label>
            <div class="col-sm-7">
                <input type="text" class="form-control job_name o_name" v-model="selected.name" @keyup="checkProgress('name', $event)" />
            </div>
        </li>

        <!--<li class="group row m-b-20">
            <label for="turnaround" class="col-sm-5">
                Order Date
            </label>
            <div class="col-sm-7">
                <div class="form-control">{{ new Date() | moment("MM/DD/YYYY") }}</div>
            </div>
        </li> -->

        <li class="group row m-b-20">
            <label for="turnaround" class="col-sm-5">
                Turnaround
            </label>
            <div class="col-sm-7">
                <select class="form-control selector o_turnaround" v-model="selected.turnaround" @change="checkProgress('turnaround', $event)" disabled="disabled">
                    <option value="null">Select One</option>
                    <option :value="turn" v-for="turn in turnaroundOptions">{{ turn.turn }}{{ (turn.price > 0) ? ' &nbsp;($' + parseFloat(turn.price).toFixed(2) + ')' : '' }}</option>
                </select>
            </div>
        </li>

        <li class="group row m-b-20">
            <label for="turnaround" class="col-sm-5">
                Shipping Address
            </label>
            <div class="col-sm-7">
                <select class="form-control o_shipping" v-model="selected.shipping" @change="checkProgress('shipping', $event)" disabled="disabled">
                    <option value="null">Select One</option>
                    <option value="new">+ New Address</option>
                    <option disabled="disabled">-------------------------------------</option>
                    <option :value="address" v-for="address in addressList">{{ address.label }}</option>
                </select>
                <transition enter-active-class="animated fadeIn fast" leave-active-class="animated fadeOut fast">
                    <div v-if="selected.shipping !== 'null'" class="m-l-10 m-t-10" v-html="printAddress(selected.shipping)"></div>
                </transition>
            </div>
        </li>

        <!--<li class="group row m-b-20">
            <label for="turnaround" class="col-sm-5">
                Blind Shipping
            </label>
            <div class="col-sm-7">
                <select class="form-control o_blind" v-model="selected.blind" @change="checkProgress('blind', $event)" disabled="disabled">
                    <option value="null">No Blind Shipping</option>
                    <option :value="address" v-for="address in addressList">{{ address.label }}</option>
                </select>
                <transition enter-active-class="animated fadeIn fast" leave-active-class="animated fadeOut fast">
                    <div v-if="selected.blind !== 'null'" class="m-l-10 m-t-10" v-html="printAddress(selected.blind)"></div>
                </transition>
            </div>
        </li> -->

        <li class="group row m-b-20">
            <label for="turnaround" class="col-sm-5">
                Shipping Method
            </label>
            <div class="col-sm-7">
                <select class="form-control o_method" v-model="selected.method" @change="checkProgress('method', $event);checkShipping()" disabled="disabled">
                    <option value="null">Select One</option>
                    <option :value="option" v-for="option in shippingOptions">
                        {{ (option.group_with_cart) ? 'Group Ship with Set ' + option.group_with_set : option.service_name + ' &nbsp;($' + option.service_price + ')' }}
                    </option>
                </select>
                <p class="shippingNote" v-if="shippingNote" v-html="shippingNote"></p>
            </div>
        </li>

        <li>
            <!-- TURNAROUND ESTIMATOR -->
            <!-- <div class="shipBlock group">
                <div class="deliverySchedule">
                    <div class="scheduleHeader primarybg"><span class="designTurnaround">Design </span>Turnaround</div>

                    <div class="scheduleEstimate">
                        <div class="countdown-text">Complete your order with approved files in the next <span class="countdown"></span></div>

                        <label for="completion">Estimated Date of Completion:</label>
                        <div class="detailDate totalDays">TBD<sup>*</sup></div>

                        <label for="estimated">Estimated Delivery:</label>
                        <div class="detailDelivery totalDays">TBD<sup>*</sup></div>

                        <p class="turn-disclaimer"><sup>*</sup>While we make every attempt to meet the stated turnaround times, turn times are not guaranteed. If your order is time sensitive we recommend contacting us prior to placing your order. <a href="/resources/turnaround-times" class="primarytext" target="_blank">more</a></p>
                    </div>
                    <div class="scheduleDesign">
                        <p>Production turnaround times begin when the design files are approved and uploaded. Design Services typically take an additional 2-3 days which is dependent on a timely response to proofs that are sent during the design process.</p>
                    </div>
                </div>
            </div>
            <p><small>Estimated Delivery is only an estimate and depends on a number of factors including, but not limited to: Meeting 12:00 PM EST file submission on day of placed order, file validation, order accuracy, changes, proofs, and weather which can all affect the final delivery date.</small></p> -->
        </li>

        <li class="group row m-b-0" v-if="shippingTotal()">
            <div class="col-sm-12">
                <div class="pull-right m-b-20" style="font-size: 30px;">${{ shippingTotal() }}</div>
            </div>
        </li>

        <li class="group row m-b-0">
            <div class="col-sm-12">
                <button :class="{disabled: (proceed !== true)}" class="btn btn-success pull-right" @click="checkProceed()">{{ button }}</button>
            </div>
        </li>

        <AddressModal width="500" v-on:addressSaved="updateAddressOptions"></AddressModal>
    </ul>
</template>
<script>
/* global Helpers */

// import _ from 'lodash'
import swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.css'
import AddressModal from './AddressModal.vue'

export default{
    name: 'ShippingSelector',
    components: {AddressModal},
    props: {
        products: {
            default: []
        },
        button: {
            default: 'Add to cart'
        },
        selected: {
            default: () => {
                return {
                    product: null,
                    product_cost: null,
                    runsize: null,
                    runsizeDescription: null,
                    colorspec: null,
                    options: null,
                    name: null,
                    turnaround: null,
                    shipping: null,
                    blind: null,
                    date: null,
                    method: null
                }
            }
        }
    },
    data () {
        return {
            shippingNote: null,
            addressesLoaded: false,
            addressList: [],
            turnaroundOptions: [],
            shippingOptions: [],
            optionGroups: {},
            selected_products: [],
            selected_options: [],
            filtered_products: [],
            runsize_cost: [],
            runsizes: [],
            min_runsize: 0,
            proceed: false
        }
    },
    beforeMount () {
        this.fetchAddressList()
    },
    mounted () {
    },
    watch: {
        selected: function (selectedNew, selectedOld) {
            this.$emit('updateSelected', selectedNew)
            if (selectedNew.runsize !== null && selectedNew.colorspec !== null && selectedNew.product !== null) {
                this.fetchTurnaround()
            }
        }
    },
    methods: {
        /**
         * Loop our products, build out all available options and init our selected prods to start with
         */
        init () {

        },

        fetchTurnaround () {
            let data = {
                product: this.selected.product.id,
                runsize: this.selected.runsize,
                colorspec: this.selected.colorspec
            }

            this.axios.post('/products/turnaround', data)
            .then((res) => {
                this.turnaroundOptions = res.data.data
            })
            .catch((err) => {
                Helpers.errorPop('Error', err)
            })
        },

        fetchAddressList (address = null, timeout = 0) {
            setTimeout(() => {
                this.axios.get('/address/list?limit=500')
                .then((res) => {
                    this.addressList = res.data.data

                    // If address exists then this was called from the address modal response
                    if (address !== null) {
                        // We found the newly saved address
                        if (this.addressList.length > 0) {
                            for (let i in this.addressList) {
                                if (this.addressList[i].id === address.id) {
                                    this.selected.shipping = this.addressList[i]
                                }
                            }
                            $('.o_blind').removeAttr('disabled')
                            this.fetchShippingOptions()

                        // Address still not saved, try again but delay a little
                        } else {
                            this.fetchAddressList(address, timeout + 500)
                        }
                    }
                })
                .catch((err) => {
                    Helpers.errorPop('Error', err)
                })
            }, timeout)
        },

        checkProceed () {
            if (this.proceed) {
                this.$emit('next')
            }
            return false
        },

        checkProgress (current, $event) {
            if (current === 'name' && $event.target.value.length > 0) {
                $('.o_turnaround').removeAttr('disabled')
            } else if (current === 'turnaround') {
                $('.o_shipping').removeAttr('disabled')
                if (this.selected.shipping) {
                    this.fetchShippingOptions()
                }
            } else if (current === 'shipping') {
                if ($event.target.value === 'new') {
                    // Popup Shipping Modal
                    this.$modal.show('AddressModal')
                } else {
                    $('.o_blind').removeAttr('disabled')
                    this.fetchShippingOptions()
                }
            } else if (current === 'method') {

            }

            if (this.selected.name !== null && this.selected.turnaround !== null && this.selected.shipping !== null && this.selected.method !== null) {
                this.proceed = true
            } else {
                this.proceed = false
            }
        },

        checkShipping () {
            if (this.selected.method.group_with_cart) {
                this.shippingNote = 'This set qualifies for group shipping with set ' + this.selected.method.group_with_set + '.<br>Group shipping total will show in the cart.<br><a href="https://support.primoprint.com/shipping/shipping-information" target="_blank">Learn More &gt;</a>'
            } else if (this.selected.method.total_sets > 0) {
                this.shippingNote = 'This set does not qualify for group shipping.<br><a href="https://support.primoprint.com/shipping/shipping-information" target="_blank">Learn More &gt;</a>'
            } else {
                this.shippingNote = null
            }
        },

        fetchShippingOptions () {
            $('.o_method').attr('disabled', 'disabled')
            $('.o_method > option:first-child').text('Calculating..')
            this.selected.method = null

            let data = {
                product: this.selected.product.id,
                runsize: this.selected.runsize,
                turnaround: this.selected.turnaround.uuid,
                turnaround_days: this.selected.turnaround.days,
                colorspec: this.selected.colorspec,
                options: this.selected.options,
                sets: '1',
                groupship: '0',
                address: this.selected.shipping.id,
                total: this.selected.product_cost,
                sub_id: '1'
            }

            this.axios.post('/products/shipping', data)
            .then((res) => {
                this.shippingOptions = res.data.data.shipping.job.facilities[0].shipping_options

                // Inject production estimate and facility code
                for (let i in this.shippingOptions) {
                    this.shippingOptions[i].facility = res.data.data.shipping.job.facilities[0].address.code
                    this.shippingOptions[i].prod_estimate = res.data.data.shipping.job.facilities[0].production_estimate

                    if (this.shippingOptions[i].group_with_cart) {
                        this.shippingNote = 'This set qualifies for group shipping with set ' + this.shippingOptions[i].group_with_set + '.<br>Group shipping total will show in the cart.<br><a href="https://support.primoprint.com/shipping/shipping-information" target="_blank">Learn More &gt;</a>'
                    }
                }
                $('.o_method').removeAttr('disabled')
                $('.o_method > option:first-child').text('Please Select')
            })
            .catch((err) => {
                Helpers.errorPop('Error', err)
            })
        },

        shippingTotal () {
            let total = 0
            if (this.selected.turnaround && this.selected.turnaround.price) {
                total += parseFloat(this.selected.turnaround.price)
            }
            if (this.selected.method && this.selected.method.service_price) {
                total += parseFloat(this.selected.method.service_price)
            }

            if (this.selected.method && this.selected.method.group_with_cart) {
                return null
            } else {
                return total.toFixed(2)
            }
        },

        printAddress (address) {
            if (address) {
                let response = ''
                response += (address.name) ? address.name + '<br />' : ''
                response += (address.company) ? address.company + '<br />' : ''
                response += (address.address1) ? address.address1 + '<br />' : ''
                response += (address.address2) ? address.address2 + '<br />' : ''
                response += (address.city) ? address.city + ', ' : ''
                response += (address.state) ? address.state + ' ' : ''
                response += (address.zip) ? address.zip : ''

                return response
            }
        },

        updateAddressOptions: function (selected) {
            this.fetchAddressList(selected, 500)
            this.$modal.hide('AddressModal')
        },

        getShippingOptions () {
            return this.shippingOptions
        },

        showModal (html) {
            swal({
                html: '<div style="text-align: left;">' + html + '</div>',
                showCloseButton: false
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// ShippingSelector.vue?21dfee27